import { useEffect } from 'react';
import { GetTokenSilentlyOptions, useAuth0 } from '@auth0/auth0-react';
import authService from '@/core/auth/services/auth-service';

/**
 * Bridges the Auth0 React SDK's `getAccessTokenSilently` (which only exists
 * inside React context) into the framework-agnostic `authService` singleton.
 *
 * This lets the background refresh for the 'auth0' login source mint a fresh
 * access token via the rotating refresh token (offline_access) without
 * bouncing the user through the /auth0 route. Renders nothing.
 */
export default function Auth0TokenBridge() {
  const { getAccessTokenSilently, isLoading } = useAuth0();

  useEffect(() => {
    // Only register once the SDK has finished initializing, so a background
    // refresh can't call into a half-loaded client and force a false logout.
    if (isLoading) return;

    authService.registerAuth0TokenGetter((options?: GetTokenSilentlyOptions) =>
      getAccessTokenSilently(options),
    );
  }, [getAccessTokenSilently, isLoading]);

  return null;
}
